<template>
	<dl>
		<dd>
			<label>咨询任务：</label>{{ consultTitle }}
		</dd>
		<dd>
			<label>注册时间：</label>{{ tjkInfoObj.registerTime }}
		</dd>
		<dd>
			<label>年龄：</label>{{ tjkInfoObj.age }}
		</dd>
		<dd>
			<label>帐号：</label>{{ tjkInfoObj.loginName }}
		</dd>
		<dd>
			<label>淘金号：</label>{{ tjkInfoObj.tjkNumber }}
		</dd>
		<dd>
			<label>姓名：</label>{{ tjkInfoObj.realName }}
		</dd>
		<dd>
			<label>性别：</label>{{ tjkInfoObj.sex }}
		</dd>
		<dd>{{ tjkInfoObj.archivesStr }}</dd>
		<dd>
			<label>获得徽章：</label>
			<template v-for="item in tjkInfoObj.tagNameList">{{ item }}; </template>
		</dd>
		<dd>
			<label>培训任务：</label>{{ tjkInfoObj.taskName }}
		</dd>
		<dd>
			<label>任务培训状态：</label>{{ tjkInfoObj.tjkTaskApplyState }}
		</dd>
		<dd>
			<label>服务店铺：</label>
			<template v-for="item in tjkInfoObj.serviceShopNameList">{{ item }}; </template>
		</dd>
		<dd>
			<label>任务服务状态：</label>
			<template v-if="tjkInfoObj.tjkTaskExecuteState == 'Leisure'">空闲</template>
			<template v-else-if="tjkInfoObj.tjkTaskExecuteState == 'Mission'">任务中</template>
		</dd>
		<dd>
			<label>客服经验：</label>{{ tjkInfoObj.kfjy }}
		</dd>
		<dd>
			<label>运营标签：</label>
			<template v-if="tjkInfoObj.operationTags">
				<span v-for="(item, index) in tjkInfoObj.operationTags" class="label-box">{{ item.operationTagName }}<i class="icon icon-cuowu" @click="delLabel(item.operationTagId, index)"></i></span>
			</template>
			<a class="add-label-btn" @click="showLabelModel">
				<span>+</span>
			</a>
		</dd>
		<dd>
			<label>备注：</label>{{ tjkInfoObj.remark }}
			<el-button type="primary" size="mini" @click="showRemarkFun">
				<template v-if="tjkInfoObj.remark">修改</template>
				<template v-else>添加</template>
			</el-button>
		</dd>

		<el-dialog title="修改备注" width="400px" :visible.sync="editRemarkObj.show" :close-on-click-modal="false">
			<el-form size="mini">
				<el-form-item :error="editRemarkObj.error" style="margin: 0">
					<el-input type="textarea" :rows="5" placeholder="请输入备注" v-model="editRemarkObj.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editRemarkObj.show = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitEditRemark" size="small">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="添加运营标签" width="400px" :visible.sync="labelObj.show" :close-on-click-modal="false">
			<el-form size="small" label-width="80px">
				<el-form-item label="类型：">
					<el-select v-model="labelObj.type" @change="changeLabelTypeFun" placeholder="请选择">
						<el-option v-for="item in labelTypeList" :key="item.operationTagCategoryId" :label="item.operationTagCategoryName" :value="item.operationTagCategoryId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关键字：" :error="labelObj.error" style="margin: 0">
					<el-select :disabled="!labelObj.type" v-model="labelObj.tagId" placeholder="请选择">
						<el-option v-for="item in labelObj.labelList" :key="item.operationTagId" :label="item.operationTagName" :value="item.operationTagId"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="labelObj.show = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitAddLabel" size="small">确 定</el-button>
			</div>
		</el-dialog>
	</dl>
</template>

<script>
export default {
	data () {
		return {
			consultTitle: null,
			tjkInfoObj: {},
			sHttpConfig: {},
			labelTypeList: [],
			editRemarkObj: {
				show: false
			},
			labelObj: {
				show: false,
				labelList: [],
				type: null,
				tagId: null,
				error: ''
			}
		}
	},
	props: {
		tjkId: {
			default: null,
		},
		sessionId: {
			default: null,
		},
		extInfos: {
			type: Array,
			default: () => []
		}
	},
	created() {
		this.init();
	},
	methods: {
		// 初始化
		init () {
			let arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'))
			let token = (arr != null) ? unescape(arr[2]) : null
			this.sHttpConfig = {
				params: {
					tjk_login_token: token
				}
			};
			for (let i = 0; i < this.extInfos.length; i++) {
				let item = this.extInfos[i];
				if (item.name == 'title') {
					this.consultTitle = item.value;
					break;
				}
			}
			this.getTJKInfo();
		},

		// 通过用户来源中是否有淘金客id判断该会话是否为淘金客在咨询，并获取咨询人的淘金客信息
		getTJKInfo () {
			let data = {
				params: {
					tjkId: this.tjkId,
					...this.sHttpConfig.params
				}
			}
			let sessionId = this.sessionId;

			this.tjkInfoObj = {};
			this.$axios.post(API_ROOT.sUrl + '/tjkOperation/tjkStatusMap/query', {}, data).then(result => {
				if(sessionId != this.sessionId) return;
				if (result.success) {
					if (result.data.list.length) {
						this.getTJKArchives(result.data.list[0]);
					} else {
						this.$emit('getTjkInfoErr')
					}
				} else {
					this.$alert('获取咨询人的淘金客信息失败，失败原因：' + result.msg);
				}
			}, response => {
				if(sessionId != this.sessionId) return;
				this.$alert('获取咨询人的淘金客信息失败，错误码(' + response + ')');
			})
		},

		// 淘金客个人档案查询接口
		getTJKArchives (obj) {
			let data = {
				params: {
					tjkId: this.tjkId,
					...this.sHttpConfig.params
				}
			}
			let sessionId = this.sessionId;

			this.$axios.post(API_ROOT.sUrl + '/tjuser/personalInfo/getManagePersonTypes', {}, data).then(result => {
				if(sessionId != this.sessionId) return;
				if (result.success) {
					let str = '';
					for (let i = 0; i < result.data.length; i++) {
						let item = result.data[i];
						if (item.typeName == '客服经验') {
							obj.kfjy = item.typeValue;
						} else if (item.typeValue) {
							str += item.typeValue + '; '
						}
					}
					obj.archivesStr = str;

					this.getTJKTask(obj);
					this.getLabelTypeList();
				} else {
					this.$alert('获取淘金客个人档案失败，失败原因：' + result.msg);
				}
			}, response => {
				if(sessionId != this.sessionId) return;
				this.$alert('获取淘金客个人档案失败，错误码(' + response + ')');
			})
		},

		// 获取淘金客当前培训任务
		getTJKTask (obj) {
			let data = {
				params: {
					tjkId: this.tjkId,
					trainingState: 'TRAINING',
					...this.sHttpConfig.params
				}
			}
			let sessionId = this.sessionId;

			this.$axios.post(API_ROOT.tjkUrl + '/tjkjobtaskApi/task/tjkApplyTaskInfoList', {}, data).then(result => {
				if(sessionId != this.sessionId) return;
				if (result.success && result.data.length) obj.taskName = result.data[0].taskName;
				this.tjkInfoObj = obj;
			}, response => {
				if(sessionId != this.sessionId) return;
				this.tjkInfoObj = obj;
			})
		},

		// 查询运营标签目录
		getLabelTypeList () {
			let data = {
				params: {
					tjkId: this.tjkId,
					...this.sHttpConfig.params
				}
			}
			let sessionId = this.sessionId;

			this.$axios.post(API_ROOT.sUrl + '/tjkOperation/operationTagCategory/queryTagCategorys', {}, data).then(result => {
				if(sessionId != this.sessionId) return;
				if (result.success) {
					this.labelTypeList = result.data
				} else {
					this.$alert('查询运营标签目录失败，失败原因：' + result.msg);
				}
			}, response => {
				if(sessionId != this.sessionId) return;
				this.$alert('查询运营标签目录失败，错误码(' + response + ')');
			})
		},

		// 显示备注弹窗
		showRemarkFun () {
			this.editRemarkObj = {
				show: true,
				remark: this.tjkInfoObj.remark
			}
		},

		// 提交备注修改
		submitEditRemark () {
			if (!this.editRemarkObj.remark) {
				this.$set(this.editRemarkObj, 'error', '备注不能为空');
				return;
			}

			let data = {
				params: {
					tjkId: this.tjkId,
					remark: this.editRemarkObj.remark,
					...this.sHttpConfig.params
				}
			}

			this.$axios.post(API_ROOT.sUrl + '/tjkOperation/tjkStatusMap/updateRemark', {}, data).then(result => {
				if (result.success) {
					this.$set(this.tjkInfoObj, 'remark', this.editRemarkObj.remark);
					this.$set(this.editRemarkObj, 'show', false);
				} else {
					this.$alert('修改备注失败，失败原因：' + result.msg);
				}
			}, response => {
				this.$alert('修改备注失败，错误码(' + response + ')');
			})
		},

		// 显示添加运营标签弹窗
		showLabelModel () {
			Object.assign(this.$data.labelObj, this.$options.data().labelObj);
			this.labelObj.show = true;
		},

		// 查询标签目录下的标签列表
		changeLabelTypeFun (val) {
			let data = {
				params: {
					tjkId: this.tjkId,
					operationTagCategoryId: val,
					...this.sHttpConfig.params
				}
			}

			this.$axios.post(API_ROOT.sUrl + '/tjkOperation/operationTag/queryTags', {}, data).then(result => {
				if (result.success) {
					this.labelObj.labelList = result.data;
				} else {
					this.$alert('查询标签列表失败，失败原因：' + result.msg);
				}
			}, response => {
				this.$alert('查询标签列表失败，错误码(' + response + ')');
			})
		},

		// 提交添加标签
		submitAddLabel () {
			if (!this.labelObj.tagId) {
				this.$set(this.labelObj, 'error', '标签不能为空');
				return;
			}

			let data = {
				params: {
					tjkId: this.tjkId,
					operationTagId: this.labelObj.tagId,
					...this.sHttpConfig.params
				}
			}

			this.$axios.post(API_ROOT.sUrl + '/tjkOperation/operationTag/markTjk', {}, data).then(result => {
				if (result.success) {
					let tagObj = {
						operationTagId: this.labelObj.tagId
					};
					for (let i = 0; i < this.labelObj.labelList.length; i++) {
						let item = this.labelObj.labelList[i];
						if (item.operationTagId == this.labelObj.tagId) {
							tagObj.operationTagName = item.operationTagName;
							break;
						}
					}

					if (!this.tjkInfoObj.operationTags) {
						this.$set(this.tjkInfoObj, 'operationTags', []);
					}
					this.$set(this.tjkInfoObj.operationTags, this.tjkInfoObj.operationTags.length, tagObj);
					this.$set(this.labelObj, 'show', false);
				} else {
					this.$alert('添加标签失败，失败原因：' + result.msg);
				}
			}, response => {
				this.$alert('添加标签失败，错误码(' + response + ')');
			})
		},

		// 删除标签
		delLabel (id, index) {
			let data = {
				params: {
					tjkId: this.tjkId,
					operationTagId: id,
					...this.sHttpConfig.params
				}
			}

			this.$axios.post(API_ROOT.sUrl + '/tjkOperation/operationTag/cancelMarkTjk', {}, data).then(result => {
				if (result.success) {
					this.$delete(this.tjkInfoObj.operationTags, index);
				} else {
					this.$alert('删除标签失败，失败原因：' + result.msg);
				}
			}, response => {
				this.$alert('删除标签失败，错误码(' + response + ')');
			})
		}
	}
}
</script>

<style scoped lang="less">
	.add-label-btn {
		position: relative;
		display: block;
		width: 38px;
		height: 38px;
		background: #bebebe;
		color: #464646;
		cursor: pointer;
		> span {
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			width: 100%;
			height: 100%;
			justify-content: center;
			align-items: center;
			font-size: 30px;
			line-height: 1;
		}
	}
	.label-box {
		display: inline-block;
		margin: 0 8px 5px 0;
		padding: 0 8px;
		border: 1px solid #d9d9d9;
		background: #f5f5f5;
		border-radius: 3px;
		line-height: 22px;
		font-size: 12px;
		color: #666;
		.icon {
			position: relative;
			right: -3px;
			font-style: normal;
			cursor: pointer;
			color: #999
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/aside/tjkUser.vue